import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  .mobile-icon {\n    width: 32px;\n    ",
        " {\n      display: none;\n    }\n  }\n  .desktop-icon {\n    width: 160px;\n    display: none;\n    ",
        " {\n      display: block;\n    }\n  }\n\n  &:hover {\n\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  width: 110px;\n  min-width: 110px;\n  height: 40px;\n  margin-top: 0;\n  transition: opacity 200ms ease;\n  &:hover{\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext } from "react";
import styled, { useTheme } from "styled-components";
import Flex from "../../../components/Box/Flex";
import { MenuContext } from "../context";
import Link from "next/link";
var StyledLink = styled(Link).withConfig({
    componentId: "sc-f63493db-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.nav;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.nav;
});
var StyledLogo = styled("img").withConfig({
    componentId: "sc-f63493db-1"
})(_templateObject1());
var Logo = function(param) {
    var href = param.href;
    var linkComponent = useContext(MenuContext).linkComponent;
    var isAbsoluteUrl = href.startsWith("http");
    var theme = useTheme();
    var logo = theme.isDark ? "/images/zswap-logo.png" : "/images/zswap-logo.png";
    var innerLogo = /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(StyledLogo, {
            src: logo,
            alt: "ZSwap Decentralized Exchange"
        })
    });
    return /*#__PURE__*/ _jsx(Flex, {
        style: {
            marginLeft: "-4px"
        },
        children: isAbsoluteUrl ? /*#__PURE__*/ _jsx(StyledLink, {
            as: "a",
            href: href,
            "aria-label": "ZSwap",
            children: innerLogo
        }) : /*#__PURE__*/ _jsx(StyledLink, {
            href: href,
            as: linkComponent,
            "aria-label": "ZSwap",
            children: innerLogo
        })
    });
};
export default /*#__PURE__*/ React.memo(Logo, function(prev, next) {
    return prev.isDark === next.isDark;
});
